import React from 'react';
import Modal from '@amzn/meridian/modal';
import { useAppDispatch, useAppSelector } from 'src/store/store';
import {
  setIsTaskGroupModalOpen,
  setSelectedTaskGroupTableRow,
} from 'src/store/adminConfigPageSlice/taskConfigPageSlice/taskConfigPageSlice';
import TaskGroupModalContent from './taskGroupModalContent/taskGroupModalContent';

// **** Components **** //

/**
 * Default component
 */
const TaskGroupModal = () => {
  const dispatch = useAppDispatch();
  const { isTaskGroupModalOpen, selectedTaskGroupTableRow } = useAppSelector((state) => state.taskConfigPage);

  // Close modal
  const onCancel = () => {
    dispatch(setIsTaskGroupModalOpen(false));
    dispatch(setSelectedTaskGroupTableRow(null));
  };

  return (
    <Modal
      title={selectedTaskGroupTableRow ? 'Edit Task Group' : 'Add New Task Group'}
      open={isTaskGroupModalOpen}
      onClose={onCancel}
      closeLabel="Close"
      aria-describedby="modal-description"
      width="600px"
      scrollContainer="modal"
    >
      <TaskGroupModalContent />
    </Modal>
  );
};

// **** Export **** //

export default TaskGroupModal;
